export const RETAILER_MESSAGE_LIMIT_CHARS = 255;

export interface CampaignCreatives {
  urls?: { [key: string]: string };
}

export interface RawCampaignApiResponse {
  id: string;
  advertiser_id: string;
  campaign_key?: string | null;
  advertiser_key?: string | null;
  status: CampaignStatus;
  created_at: string;
  updated_at: string;
  name: string;
  active_from?: string | null;
  active_to?: string | null;
  budget_total_cents?: number | null;
  budget_total_left_cents?: number | null;
  budget_total_left_percent?: number | null;
  budget_limit?: CampaignBudgetLimit | null;
  custom?: any;
  purchase_order_number?: string | null;
  digital_services_act?: DigitalServicesActInfo | null;
  retailer_tags?: string[] | null;
}

export enum CampaignStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum CampaignPatchStatusEnum {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface CampaignBudgetLimit {
  budget_cents: number;
  budget_interval: CampaignBudgetLimitBudgetInterval;
}

export enum CampaignBudgetLimitBudgetInterval {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export interface DigitalServicesActInfo {
  behalf: string;
  paid: string;
}

export interface RawCreateCampaignRequestData {
  advertiser_id?: string | null;
  campaign_key?: string | null;
  advertiser_key?: string | null;
  name: string;
  active_from?: string | null;
  active_to?: string | null;
  budget_total_cents?: number | null;
  budget_limit: CampaignBudgetLimit | null;
  custom?: any;
  purchase_order_number?: string | null;
  digital_services_act?: DigitalServicesActInfo | null;
  retailer_tags?: string[] | null;
}

export interface RawUpdateCampaignRequestData {
  campaign_key: string | null;
  advertiser_key: string | null;
  name: string;
  status: CampaignUpdateStatusEnum;
  active_from: string | null;
  active_to: string | null;
  budget_total_cents: number | null;
  budget_limit: CampaignBudgetLimit | null;
  custom?: any;
  purchase_order_number: string | null;
  digital_services_act: DigitalServicesActInfo | null;
  retailer_tags?: string[] | null;
}

export enum CampaignUpdateStatusEnum {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export function createUpdateCampaignRequestData(
  data: RawCampaignApiResponse,
): RawUpdateCampaignRequestData {
  return {
    status: data.status as unknown as CampaignUpdateStatusEnum,
    active_from: data.active_from ?? null,
    active_to: data.active_to ?? null,
    advertiser_key: data.advertiser_key ?? null,
    budget_total_cents: data.budget_total_cents ?? null,
    budget_limit: data.budget_limit ?? null,
    campaign_key: data.campaign_key ?? null,
    custom: data.custom,
    name: data.name,
    purchase_order_number: data.purchase_order_number ?? null,
    digital_services_act: data.digital_services_act ?? null,
    retailer_tags: data.retailer_tags ?? null,
  };
}

export function createCreateCampaignRequestData(
  campaign: RawCreateCampaignRequestData,
): RawCreateCampaignRequestData {
  return {
    active_from: campaign.active_from,
    active_to: campaign.active_to,
    advertiser_id: campaign.advertiser_id,
    budget_total_cents: campaign.budget_total_cents,
    budget_limit: campaign.budget_limit,
    custom: campaign.custom,
    name: campaign.name,
    purchase_order_number: campaign.purchase_order_number,
    digital_services_act: campaign.digital_services_act,
    retailer_tags: campaign.retailer_tags,
  };
}
